<template>
  <div>
    <van-popup round style="width: 80%" v-model="showTag" closeable :close-on-click-overlay="false" close-icon="clear"
               @closed="onClosed">
      <div class="flex column main">
        <h3 class="flex0" style="height: 50px"></h3>
        <div class="flex1 overflow-y-auto pb30 pl15 pr15">
          <table>
            <tr>
              <th>项目名称</th>
              <th>地点</th>
            </tr>
            <tr v-for="(data,index) in allList" :key="index">
              <td>{{ data.name }}</td>
              <td>{{ data.address }}</td>
            </tr>
          </table>
        </div>
        <div class="footer flex0 pl30 pr30 pb15 pt15">
          <p class="color_999 mt15">
            注意事项：<br>
            住院当天需持<span class="color_red">48H内浙江省内核酸阴性报告</span>方可入住病房。
          </p>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import VTabs from "@/plugins/v-tabs";
import NoData from "@/plugins/no-data";
import {isEmpty} from "@/lib/util";
import {dhry_jc_status, dhry_jy_status, handlerDhryAddressList} from "@/page/dhry/config";

export default {
  name: "confirm",
  filters: {},
  components: {NoData, VTabs},
  data() {
    return {
      currTab: '待完成',
      tabs: [{label: '待完成'}, {label: '全部'}],
      title: "",
      active: 0,
      message: "",
      icon: require('@/assets/ncp/icon-医院@3x.png'),
      allList: [],
      currHos: {},
      confirmBtnText: "我知道了",
      showTag: false
    }
  },
  methods: {
    open() {
      this.showTag = true;
    },
    close() {
      this.showTag = false;
    },
    selectThis(data) {
      this.type = 'confirm';
      this.currHos = data;
      this.close()
    },
    onClosed() {
      this.$emit('closed', this.type, this.currHos);
    },
    onClick(type) {
      this.type = type;
      this.close()
    },
    onChange(data) {
      // Log('data111111111111', data);
      if (isEmpty(data)) return;
      this.currTab = data.label;

    }
  },
}
</script>

<style scoped lang="scss">
.main {
  max-height: 70vh;
}


table {
  border-collapse: collapse;
  width: 100%;
  table-layout: fixed;

  td, th {
    color: #333333;
    height: 30px;
    width: 50%;
    border: 1px solid #CBE0FF;
    font-size: 13px;
    text-align: center;
    font-weight: normal;
  }

  th {
    background-color: #EAF3FF;
    color: #558EE3;
  }
}

</style>



// WEBPACK FOOTER //
// src/plugins/dialog/dh-dzd.vue